import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function SelectActionButton(props) {
    const { className, type = 'button', children, icon, ...rest } = props;

    return (
        <button type={type} className={cn('flex items-center gap-2 text-left px-2 h-7', className)} {...rest}>
            {icon && <span className="flex items-center justify-center shrink-0">{icon}</span>}

            <span className="text-sm font-medium">{children}</span>
        </button>
    );
}

SelectActionButton.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    children: PropTypes.node,
    type: PropTypes.oneOf(['button', 'submit']),
    icon: PropTypes.node,
};
